module.exports = __webpack_public_path__ + "static/mainmeshslicer-b2eaf26eae95f8a72300c729e1447dfa.gif";